import { concatenateUserGroups } from './concatenate-user-groups';

const LABELS = {
  student: 'Students',
  staff: 'Staff',
};

export const getUserGroupString = ({
  type,
  selectedUserGroups,
  allUserGroups,
}) => {
  if (!selectedUserGroups.length) {
    return null;
  }

  const userGroupPairs = selectedUserGroups.map((code) => {
    const name = allUserGroups[type].find((group) => group.code === code)?.name;
    return `${code} - ${name}`;
  });

  return `${LABELS[type]} (${concatenateUserGroups(userGroupPairs)})`;
};
